export const MAPS = '@@maps/MAPS';
export const TERRITORIAL_DIVISION = '@@maps/TERRITORIAL_DIVISION';
export const INFRASTRUCTURE = '@@maps/INFRASTRUCTURE';
export const ANNOUNCEMENT_LOAD = '@@maps/ANNOUNCEMENT_LOAD';



// WEBPACK FOOTER //
// ./src/app/Maps/actionTypes.js